import { FC, useEffect } from 'react'
import { createPortal } from 'react-dom'

import { Button, Typography } from '@/components/ui'

import Cancel from '@/assets/icons/cancel-3.svg'
import Trash from '@/assets/icons/trash.svg'

interface IDeleteSegmentConfirmProps {
	x: number
	y: number
	onCancel: () => void
	onDelete: () => void
}

const DeleteSegmentConfirm: FC<IDeleteSegmentConfirmProps> = ({
	x,
	y,
	onCancel,
	onDelete
}) => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape') onCancel()
		}

		const handlePointerDown = (event: PointerEvent) => {
			const target = event.target as HTMLElement | null

			if (target?.closest('[data-delete-segment-confirm]')) return

			onCancel()
		}

		const handleScroll = () => {
			onCancel()
		}

		document.addEventListener('keydown', handleKeyDown)
		document.addEventListener('pointerdown', handlePointerDown)
		document.addEventListener('scroll', handleScroll, true)

		return () => {
			document.removeEventListener('keydown', handleKeyDown)
			document.removeEventListener('pointerdown', handlePointerDown)
			document.removeEventListener('scroll', handleScroll, true)
		}
	}, [onCancel])

	return createPortal(
		<div
			data-delete-segment-confirm
			style={{
				left: x,
				top: y
			}}
			className='fixed z-50 flex w-[397px] flex-col gap-10 rounded-[16px] bg-white p-6 shadow-[0_4px_16px_rgba(0,0,0,0.12)]'
			onPointerDown={event => event.stopPropagation()}
		>
			<Typography variant='text-large' className='text-neutral-900'>
				Delete highlight? This can't be undone
			</Typography>

			<div className='flex justify-end gap-4'>
				<Button
					className='rounded-[8px] !px-4 !py-2 bg-white hover:bg-neutral-200'
					classNameText='flex items-center gap-2 text-neutral-900 hover:bg-neutral-200'
					onClick={onCancel}
				>
					<Cancel className='w-3 h-3' />
					<span>Cancel</span>
				</Button>

				<Button
					className='rounded-[8px] bg-red-460 px-4 py-2 hover:bg-red-600'
					classNameText='flex items-center gap-2 text-white'
					onClick={onDelete}
				>
					<Trash className='w-4 h-4 text-white' />
					<span>Delete</span>
				</Button>
			</div>
		</div>,
		document.body
	)
}

export default DeleteSegmentConfirm
